"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.map");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _CardFooter = _interopRequireDefault(require("./CardFooter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  bodyElementType: _propTypes["default"].elementType,
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  colorBar: _propTypes["default"].bool,
  customFooter: _propTypes["default"].node,
  heading: _propTypes["default"].string,
  href: _propTypes["default"].string,
  hrefText: _propTypes["default"].string,
  media: _propTypes["default"].string,
  primaryAction: _propTypes["default"].func,
  primaryButtonText: _propTypes["default"].string,
  secondaryAction: _propTypes["default"].func,
  secondaryButtonText: _propTypes["default"].string
};
var defaultProps = {
  bodyElementType: 'p'
};

var Card = function Card(props) {
  var bodyElementType = props.bodyElementType,
      children = props.children,
      className = props.className,
      colorBar = props.colorBar,
      customFooter = props.customFooter,
      heading = props.heading,
      href = props.href,
      hrefText = props.hrefText,
      media = props.media,
      primaryAction = props.primaryAction,
      primaryButtonText = props.primaryButtonText,
      secondaryAction = props.secondaryAction,
      secondaryButtonText = props.secondaryButtonText,
      otherProps = _objectWithoutPropertiesLoose(props, ["bodyElementType", "children", "className", "colorBar", "customFooter", "heading", "href", "hrefText", "media", "primaryAction", "primaryButtonText", "secondaryAction", "secondaryButtonText"]);

  var hasActionInBody = false;

  var body = _react["default"].Children.map(children, function (child) {
    if (typeof child === 'object' && 'type' in child && child.type === 'a') {
      var childClassName = child.props.className;
      hasActionInBody = true;
      return /*#__PURE__*/_react["default"].cloneElement(child, {
        className: (0, _classnames["default"])(childClassName, 'grv-card__link', {
          'grv-card__link--expand': true
        })
      });
    }

    return child;
  });

  var classes = (0, _classnames["default"])('grv-card', {
    'grv-card--color-bar': colorBar
  }, className);
  var contentClassName = (0, _classnames["default"])('grv-card__content', {
    'grv-card__link-scope': hasActionInBody && (primaryAction || secondaryAction)
  });
  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, otherProps, {
    className: classes
  }), media ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "grv-card__media",
    style: {
      backgroundImage: media
    }
  }) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: contentClassName
  }, heading ? /*#__PURE__*/_react["default"].createElement("h2", {
    className: "grv-card__heading"
  }, heading) : null, body ? /*#__PURE__*/_react["default"].createElement(bodyElementType, {
    className: 'grv-card__body'
  }, body) : null), /*#__PURE__*/_react["default"].createElement(_CardFooter["default"], {
    customFooter: customFooter,
    href: href,
    hrefText: hrefText,
    primaryAction: primaryAction,
    primaryButtonText: primaryButtonText,
    secondaryAction: secondaryAction,
    secondaryButtonText: secondaryButtonText
  }));
};

Card.propTypes = propTypes;
Card.defaultProps = defaultProps;
var _default = Card;
exports["default"] = _default;